import React from 'react';
import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';
import {
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
  TableChart as TableChartIcon,
} from '@mui/icons-material';
import { ViewMode } from '../../pages/People';

/**
 * ViewModeToggle Component
 *
 * Toggle buttons for switching between Grid, List, and Table views
 *
 * Features:
 * - Three view modes: Grid, List, Table
 * - Icons for each mode
 * - Saves preference to localStorage (handled by parent)
 *
 * @component
 * @param {ViewModeToggleProps} props - Component props
 * @returns {JSX.Element} View mode toggle buttons
 */
interface ViewModeToggleProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  onChange,
}) => {
  // ===== Event Handlers =====
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newMode: ViewMode | null
  ) => {
    if (newMode !== null) {
      onChange(newMode);
    }
  };

  // ===== Render =====
  return (
    <Box>
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={handleChange}
        aria-label="view mode"
        size="small"
      >
        <ToggleButton value="grid" aria-label="grid view">
          <ViewModuleIcon />
        </ToggleButton>
        <ToggleButton value="list" aria-label="list view">
          <ViewListIcon />
        </ToggleButton>
        <ToggleButton value="table" aria-label="table view">
          <TableChartIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ViewModeToggle;
